<template>
  <page-view>
    <div class="notice_wrapper">
      <div style="display: flex; gap: 12px; align-items: center;">
        <a-input
          v-model="queryParam.uid"
          placeholder="用户Id"
          style="width: 220px;"
        />
        <a-input
          v-model="queryParam.certName"
          placeholder="姓名"
          style="width: 220px;"
        />
        <a-input
          v-model="queryParam.certPhone"
          placeholder="手机号"
          style="width: 220px;"
        />
        <a-select
          v-model="queryParam.hasCertify"
          style="width: 240px"
          placeholder="认证结果"
          :options="[
            { label: '成功', value: true },
            { label: '失败', value: false }
          ]"
        >
        </a-select>
        <a-button
          type="primary"
          @click="
            () => {
              $refs.table.refresh(false);
            }
          "
          class="query_btn"
          >查询</a-button
        >
      </div>

      <div class="notice_table">
        <s-table ref="table" rowKey="id" :columns="columns" :data="dataSource">
        </s-table>
      </div>
    </div>
  </page-view>
</template>

<script>
import { PageView } from "@/layouts";
import { queryVertifyList } from "@/api";
import { formatDate } from "@/utils/util";
import { STable } from "@/components";
export default {
  components: {
    PageView,
    STable
  },

  data() {
    return {
      queryParam: {
        type: "all"
      },
      columns: [
        {
          title: "用户Id",
          dataIndex: "uid"
        },
        {
          title: "姓名",
          dataIndex: "certName"
        },
        {
          title: "手机号",
          dataIndex: "certPhone"
        },
        {
          title: "认证类型",
          dataIndex: "type",
          customRender: (text, record) =>
            (record.hasMobileCertify && "手机验证") ||
            (record.hasFaceCertify && "人脸认证") ||
            "-"
        },
        {
          title: "认证结果",
          dataIndex: "hasCertify",
          customRender: text => (text ? "成功" : "失败")
        },
        {
          title: "认证时间",
          dataIndex: "certifyTime",
          customRender: formatDate
        }
      ],
      dataSource: parameter => {
        let params = JSON.parse(JSON.stringify(this.queryParam));
        return queryVertifyList(Object.assign(parameter, params)).then(
          result => {
            console.log(result.data);
            return result.data;
          }
        );
      }
    };
  }
};
</script>

<style lang="less" scoped>
.notice_wrapper {
  background-color: #fff;
  padding: 24px;
  box-shadow: 0px 2px 20px rgba(15, 41, 131, 0.1);
  border-radius: 4px;
  .query_btn {
    margin-left: 64px;
  }
  .add_btn {
    margin-left: 12px;
  }

  .delete_btn {
    cursor: pointer;
    color: #1890ff;
  }
  .notice_table {
    margin-top: 24px;
  }
}
</style>
